// This is the parent component of a modal: ModalAdminindustrysectorsone

import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DeleteModal from "./DeleteModal";
import GenericModal from "./GenericModal";
import ModalAdminindustryedit from "./ModalAdminindustryedit";
import ModalAdminindustrysectorsone from "./ModalAdminindustrysectorsone";
import Navbar from "./Navbar";
import {
  deleteIndustrysectorparentItems,
  fetchIndustrysectorparentItems,
} from "./redux/slices/IndustrysectorcategoriesThunks";
import {
  deleteIndustrysectorchildItem,
  deleteIndustrysectorchildMany,
  fetchIndustrysectorchildItems,
} from "./redux/slices/IndustrysectorchildThunks";

export default function Adminindustrysectorsone() {
  // Modal logic goes here for Adminindustrysectorsone
  const dispatch = useDispatch();
  const industryParent = useSelector(
    (state) => state.industrysectorparent.items
  );
  const industryChild = useSelector((state) => state.industryChild.items);
  const [showData, setShowData] = useState([]);
  const [allShowData, setAllShowData] = useState([]);
  const [tableColumn, setTableColumn] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [industryParents, setIndustryParents] = useState([]);
  const [search, setSearch] = useState("");
  const [active, setActive] = useState("");

  const openModal = () => setIsModalOpen(true);
  const closeModal = async () => {
    await getIndustry();
    setIsModalOpen(false);
  };

  const openEditModal = () => setIsEditModalOpen(true);
  const closeEditModal = async () => {
    await getIndustry();
    setIsEditModalOpen(false);
  };

  const editClick = (key, item) => {
    setActive(item);
    openEditModal();
  };

  const openDeleteModal = (item) => {
    setActive(item);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = async () => {
    await getIndustry();
    setIsDeleteModalOpen(false);
  };

  const deleteClick = async () => {
    if (active.type == "Child") {
      await dispatch(deleteIndustrysectorchildItem(active));
    } else {
      await dispatch(deleteIndustrysectorparentItems(active));
      await dispatch(deleteIndustrysectorchildMany(active));
    }
    closeDeleteModal();
  };

  useEffect(() => {
    if (allShowData.length > 0) {
      const lowerSearch = search.toLowerCase();

      const filtered = allShowData.filter((val) =>
        [val.industry_sector, val.type]
          .filter(Boolean) // Ignore null/undefined
          .some((field) => field.toLowerCase().includes(lowerSearch))
      );

      setShowData(filtered);
    }
  }, [search, industryChild]);

  useEffect(() => {
    if (industryParent.length > 0) {
      const tableColumns = [
        { key: "industry_sector", width: "40%" },
        { key: "type", width: "40%" },
        { key: "faq_action", width: "40%" },
      ];
      var arr = [];
      industryParent.length > 0 &&
        industryParent.map((value) => {
          const childs =
            industryChild.length > 0
              ? industryChild.filter((val) => {
                  return val.industry_sector_parent_id == value._id;
                })
              : [];
          const obj = {
            _id: value?._id,
            industry_sector: value.sector_name ? value.sector_name : "",
            type: "Parent",
          };
          arr.push(obj);
          childs.length > 0 &&
            childs.map((val, idx) => {
              const child_obj = {
                _id: val?._id,
                industry_sector: val.sector_name ? val.sector_name : "",
                type: "Child",
                parent_id: val?.industry_sector_parent_id,
              };
              arr.push(child_obj);
            });
        });
      setTableColumn(tableColumns);
      setShowData(arr);
      setAllShowData(arr);
    }

    if (industryParent.length > 0) {
      var arr = [];
      industryParent.map((val, idx) => {
        var obj = {};
        obj.value = val._id;
        obj.label = val.sector_name;
        arr.push(obj);
      });
      setIndustryParents(arr);
    }
  }, [industryChild, industryParent]);

  const getIndustry = () => {
    try {
      dispatch(fetchIndustrysectorparentItems());
      dispatch(fetchIndustrysectorchildItems());
      const tableHeaders = [
        { label: "Industry Sector", width: "40%" },
        { label: "Type", width: "40%" },
        { label: "Action", width: "40%" },
      ];
      setTableHeader(tableHeaders);
    } catch (e) {
      console.log(e, "error");
    }
  };

  useEffect(() => {
    getIndustry();
  }, []);

  return (
    <RootWrapperAdminindustrysectorsone>
      <Navbar />
      <Dashboard>
        <Wrapper>
          <Left_0001>
            <PRTNR.SidebarNav />
          </Left_0001>
          <Right>
            <DashboardHeader>
              <Frame1462>
                <WelcomeJames>Categories - Industry Sector</WelcomeJames>
              </Frame1462>
              <Frame1461>
                <AIMEButton
                  size="small"
                  onClick={() => {
                    openModal();
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    background: "rgb(33, 37, 67)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Add
                  </span>
                </AIMEButton>
              </Frame1461>
            </DashboardHeader>
            <ContentBox>
              <TableTitle>
                <Frame1431>
                  <Frame1431_0001>
                    <Title>All</Title>
                  </Frame1431_0001>
                </Frame1431>
                <Frame1432>
                  <GFieldsStacked>
                    <GFieldsStacked_0001>
                      <PRTNR.Input
                        type="text"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </GFieldsStacked_0001>
                  </GFieldsStacked>
                </Frame1432>
              </TableTitle>
              <PRTNR.TableComponent
                data={showData}
                tableColumn={tableColumn}
                tableHeader={tableHeader}
                editClick={editClick}
                deleteClick={openDeleteModal}
              />
            </ContentBox>
          </Right>
        </Wrapper>
      </Dashboard>
      <Footer>
        <Section>
          <Section_0001>
            <Wrapper_0001>
              <Frame38>
                <_2025PaartnerLimitedAllRightsReserved>
                  © 2025 Paartner Limited. All Rights Reserved
                </_2025PaartnerLimitedAllRightsReserved>
              </Frame38>
            </Wrapper_0001>
          </Section_0001>
        </Section>
      </Footer>

      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalAdminindustrysectorsone
          isOpen={isModalOpen}
          onClose={closeModal}
          industryParent={industryParents}
        />
      </GenericModal>
      <GenericModal isOpen={isEditModalOpen} onClose={closeEditModal}>
        <ModalAdminindustryedit
          isOpen={isEditModalOpen}
          onClose={closeEditModal}
          industryParent={industryParents}
          active={active}
        />
      </GenericModal>
      <GenericModal isOpen={isDeleteModalOpen} onClose={closeDeleteModal}>
        <DeleteModal
          isOpen={isDeleteModalOpen}
          onDelete={deleteClick}
          itemName={"Sector"}
        />
      </GenericModal>
    </RootWrapperAdminindustrysectorsone>
  );
}

const RootWrapperAdminindustrysectorsone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
  padding: 32px 0px;
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 298px;
  box-sizing: border-box;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 878px;
  box-sizing: border-box;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1462 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 772px;
  box-sizing: border-box;
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: center;
`;

const Frame1461 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const ContentBox = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const TableTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1431 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Title = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Frame1432 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 782px;
  box-sizing: border-box;
`;

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
`;

const GFieldsStacked_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 4px;
  box-sizing: border-box;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Section = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame38 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2025PaartnerLimitedAllRightsReserved = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1431_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;
